<template>
  <div>
    <uni-popup ref="createCheck" type="bottom">
      <uni-card title="申请单" :is-full="true" :note="true">
        <div class="gridClass">
          <uni-list>
            <uni-list-item>
              <template v-slot:title>
                <div class="patientName">
                  <span>{{ recordItem.patientName }}</span>
                  <span class="sex">
                    {{ getKeyValueText('sex_code', recordItem.patientSex) }}
                  </span>
                  <span class="age">
                    {{ age }}
                  </span>
                </div>
              </template>
              <template v-slot:note>
                <div class="preType">
                  <span>
                    {{ getKeyValueText('item_type', checkType) + '申请单' }}
                  </span>
                </div>
              </template>
              <template v-slot:footer>
                <div class="serviceType">
                  <!-- ' ' 中间的空格不要去掉 就是这么写的 -->
                  <span>
                    {{ getKeyValueText('patient_fee_type', recordItem.patientFeeType) || ' ' }}
                  </span>
                </div>
              </template>
            </uni-list-item>
          </uni-list>
          <div class="grid_wrap">
            <div class="row_wrap fst_row">
              <span class="title">诊断：</span>
              <div style="flex: 1">
                <template v-for="(item, i) in sysList">
                  <span
                    :class="
                      item.symptomType === '3'
                        ? 'diagnose_wrap meng_text'
                        : 'diagnose_wrap symptom_text'
                    "
                  >
                    {{ item.symptomName || '' }}{{ i !== sysList.length - 1 ? '，' : '' }}
                  </span>
                </template>
              </div>
            </div>
            <div class="row_wrap">
              <span class="title">项目：</span>
              <img
                class="add_img"
                src="@funcPuzzle/mini_doctor/add.png"
                @click="addDrug"
              />
            </div>
          </div>
          <ms-check-show
            :checkList="checkList"
            :checkType="checkType"
            :page="'申请单'"
            :viewAction="false"
          />
        </div>
        <template v-slot:footer>
          <div class="footer-box" @click="createPrescrip">
            <span class="btn">提交</span>
          </div>
        </template>
        <template v-slot:close>
          <uni-icons type="closeempty" color="#666" @click="close" />
        </template>
      </uni-card>
    </uni-popup>
    <ms-add-check ref="addCheck" v-model:visible="showAddDrug" :checkType="checkType" />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { getKeyValueText, birthToAge } from '@/views/funcPuzzle/utils/util.js'
import { createTreatment, getVisitRecordOnlineDetail } from '@/views/funcPuzzle/utils/index.js'
import MsCheckShow from '@/views/funcPuzzle/components/ms-check-show/ms-check-show.vue'
import MsAddCheck from '@/views/funcPuzzle/components/ms-add-check/ms-add-check.vue'
import { signatureMethod } from '@/utils/signture/index.js'

export default {
  components: {
    MsCheckShow,
    MsAddCheck
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Array, String],
      default: () => {
        return []
      }
    },
    recordItem: {
      type: [Object, String],
      default: ''
    },
    symptomName: {
      type: [Object, String],
      default: ''
    }
  },
  data() {
    return {
      validDays: '3',
      birthToAge,
      showAddDrug: false,
      checkList: [],
      checkType: '',
      prescripSort: '1',
      canSubmit: true,
      arr: [],
      form: {
        chineseDrugUsage: 'A',
        times: '2',
        processMethod: '1',
        packageNumber: '200',
        processMode: 'A001',
        processSolution: '02',
        prescripDesc: '',
        doesNumber: '1'
      }
    }
  },
  computed: {
    ...mapState('user', ['userInfos']),
    hospitalID() {
      return this.userInfos.hospitalID
    },
    sysList() {
      return this.symptomName
    },
    age() {
      return this.recordItem.patientAge
        ? this.recordItem.patientAge
        : birthToAge(this.recordItem.patientBirth)
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.$refs.createCheck.open()
      } else {
        this.close()
      }
    }
  },
  beforeUnmount() {
    this.$bus.off('doesNumber')
  },
  methods: {
    usageData(val) {
      this.form = val
    },
    boilData(val) {
      this.form = val
    },
    updateUsage() {
      this.$refs.usage.open()
      this.close()
    },
    updateBoilMsg() {
      this.$refs.boilmsg.open()
      this.close()
    },
    showPrescripClass() {
      this.$refs.prescripclass.open()
      this.setPrescripClass('1')
    },
    getCal(val) {
      return typeof val
    },
    getKeyValueText,
    selectPre(i) {
      this.selectedIndex = i
    },
    close() {
      if (!this.$refs.createCheck) {
        return false
      }
      this.$emit('update:visible', false)
      this.$refs.createCheck.close()
    },
    checkOne(e) {
      this.validDays = e.detail.value
    },
    addDrug() {
      this.$refs.addCheck.open()
      this.$refs.createCheck.close()
    },
    groupBy(arr, key) {
      const obj = {}
      arr.sort((a, b) => a[key] - b[key])
      arr.map(item => {
        const _key = item[key]
        if (obj[_key]) {
          obj[_key].push(item)
        } else {
          obj[_key] = [item]
        }
      })
      return obj
    },
    judgeList(val) {
      this.arr = val.filter(item => {
        return item.drugID
      })
      const groupObj = this.groupBy(this.arr, 'useDrugTime')

      const finArr = []
      for (const i in groupObj) {
        finArr.push(groupObj[i])
      }

      finArr
        .filter(value => {
          return value.length === 1
        })
        .filter(item => {
          if (item[0].isDrugInducer && item[0].isDrugInducer !== '0') {
            uni.showToast({
              title: '提交失败，只有药引没有对应的药品信息',
              icon: 'none'
            })
            this.canSubmit = false
          }
        })
      return this.canSubmit
    },
    deWeight(arr) {
      // let obj = {}
      // arr.reduce(function(item, next) {
      //   obj[next.itemIDfromHis]
      //     ? ''
      //     : (obj[next.itemIDfromHis] = true && item.push(next))
      //   return item
      // }, [])

      // let obj = {}
      // arr.reduce(function(a, b) {
      //   obj[b.itemIDfromHis] ? '' : (obj[b.itemIDfromHis] = true && a.push(b))
      //   return a
      // }, [])
      // let name = 'itemIDfromHis'
      const map = new Map()
      for (const item of arr) {
        if (!map.has(item.itemIDfromHis)) {
          map.set(item.itemIDfromHis, item)
        }
      }
      return [...map.values()]
      // return arr
    },
    createPrescrip() {
      if (this.checkList.length < 1) {
        uni.showToast({
          title: '请至少选择一个项目',
          duration: 2000,
          icon: 'none'
        })
        // console.log('checkList', this.checkList)
        return
      }
      const groupRes = this.groupBy(this.checkList, 'itemIDfromHis')
      let list = []
      const idArr = []
      for (const i in groupRes) {
        if (groupRes[i].length === 1) {
          idArr.push(i)
        }
      }
      list = JSON.parse(JSON.stringify(this.checkList))

      idArr.forEach(v => {
        const index = list.findIndex(item => item.itemIDfromHis === v)
        list.splice(index, 1)
      })

      const titleList = this.deWeight(list)

      const titleArr = titleList.map(item => {
        return '【' + item.itemName + '】'
      })
      const title = titleArr.join('/ ') + '项目重复'

      if (titleList && titleList[0]) {
        uni.showModal({
          content: title,
          showCancel: false,
          buttonText: '确定',
          success: res => {
            if (res.confirm) {
              return false
            }
          }
        })
        return false
      }

      uni.showLoading({
        title: '保存中'
      })
      this.canSubmit = true

      this.checkList.map(item => {
        item.id = ''
        return item
      })

      const submitParam = {
        hospitalID: this.recordItem.hospitalID,
        id: this.recordItem.id,
        prescripOrderType: this.checkType,
        treatmentDetailList: this.checkList,
        prescripSort: this.prescripSort,
        amount: this.checkList.length,
        feeType: '7',
        prescriporderNo: this.prescriporderNo
      }
      // 白名单接口
      createTreatment(submitParam).then(rs => {
        uni.hideLoading()
        if (rs.code == '0') {
          this.$refs.createCheck.close()
          this.getDetail(rs.prescriporderNo)
          this.$bus.emit('showCheckDetail')
        } else if (rs.code === -4) {
          // TODO 20230215写 - 对应当期需求
          this.needSign(rs)
          return
        } else {
          uni.showToast({
            title: rs.codeDesc,
            icon: 'none'
          })
        }
      })
    },
    needSign(res) {
      // console.log('needSign')
      const _this = this
      const signMethod = new signatureMethod({
        flowId: res?.flowId, // e签宝使用，后台返回
        accountId: res?.accountId, // e签宝使用，后台返回
        prescripNum: res.prescripNum, // 处方编号，后台返回
        doctorId: res.doctorId, // 医生ID，后台返回
        signType: res.signType, // 签名类型，后台返回
        signUrl: res.signUrl, // 签名地址，后台返回
        businessType: res.businessType,
        response: res, // 后台返回的数据
        // 查询签名前调用的方法（提示用）
        beforeConfirm() {
          // console.log('??????beforeConfirm')
          // afterCheckModel() 继续查询
          uni.showModal({
            title: '提示',
            content: '签名是否已完成？',
            cancelText: '取消',
            confirmText: '已完成',
            success: res => {
              if (res.confirm) {
                signMethod.afterCheckModel()
              } else {
                _this.$refs.createCheck.close()
                _this.getDetail(res.prescripNum)
                _this.$bus.emit('showCheckDetail')
              }
            }
          })
        },
        // 签名成功时
        signSuccess() {
          _this.$refs.createCheck.close()
          _this.getDetail(res.prescripNum)
          _this.$bus.emit('showCheckDetail')
        },
        // 签名失败时调用
        signFail() {
          // _this.$refs.createCheck.close()
          // _this.getDetail(res.prescripNum)
          // _this.$bus.$emit('showCheckDetail')
        },
        // e签宝调用失败
        eSignFail() {
          uni.showToast({
            title: '调用e签宝小程序失败，请重试',
            icon: 'none'
          })
        }
      })
    },
    getDetail(prescriporderNo) {
      getVisitRecordOnlineDetail({
        visitID: this.recordItem.visitID
      }).then(res => {
        this.checkList = res.TreatmentList

        const checkItem = this.checkList.filter(item => {
          return item.prescriporderNo === prescriporderNo
        })[0]

        const detail = Object.assign(
          {},
          {
            checkItem,
            visitNo: res.reginfo.visitNo,
            symptomName: res.VisitRecordOnlineDetail.symptomName,
            patientPhone: res.VisitRecordOnlineDetail.patientPhone
          }
        )
        this.$bus.emit('checkDetail', detail)
      })
    }
  },
  mounted() {
    // this.$bus.$on('usageItem', (val) => {
    //   this.$refs.createCheck.open()
    //   this.form = Object.assign(this.form, val)
    // })

    // this.$bus.$on('boilMsgItem', (val) => {
    //   this.$refs.createCheck.open()
    //   this.form = Object.assign(this.form, val)
    // })

    this.$bus.on('checkItem', val => {
      this.$refs.createCheck.open()
      const data = Object.assign(val, {
        prescripOrderType: this.checkType
      })
      this.checkList.push(data)
    })

    this.$bus.on('checkType', val => {
      this.checkType = val

      this.checkList = []

      this.$refs.createCheck.open()
      // 国际蒙医 检验项目新增信息弹窗
      if (this.hospitalID == '26373' && this.checkType == 2) {
        uni.showModal({
          content:
            '为了计费准确，采血相关的检验项目建议开在同一张申请单上(点击+添加按钮即可在同一申请单添加多个项目）',
          confirmText: '知道了',
          showCancel: false,
          success: () => {}
        })
      }
      // console.log('baseOrgan', baseOrgan)
      // console.log('checkType', this.checkType)
    })

    this.$bus.on('showSelectCheck', val => {
      this.prescriporderNo = ''
    })

    this.$bus.on('updateCheck', ({ val, val2, val3 }) => {
      this.prescriporderNo = val.prescriporderNo
      this.prescripSort = val2 + 1 + ''

      this.checkType = val3
      this.checkList = val.treatmentDetailList

      // eslint-disable-next-line vue/no-mutating-props
      // this.recordItem = Object.assign(this.recordItem, {
      //   patientName: val.patientName,
      //   patientSex: val.sex,
      //   symptomName: val.diagnosis,
      //   patientAge: val.age
      // })

      this.$refs.createCheck.open()
    })
    this.$bus.on('createNewCheck', val2 => {
      this.prescripSort = !val2 ? '1' : val2 + 1 + ''
    })

    this.$bus.on('deleteCheck', list => {
      this.checkList = list
    })

    this.$bus.on('cancelAddCheck', val => {
      this.$refs.createCheck.open()
    })
  },
  unmounted() {
    this.$bus.off('showCheckDetail')
    this.$bus.off('checkDetail')
  }
}
</script>

<style lang="scss">
.gridClass ::v-deep .uni-list:after {
  background-color: transparent !important;
}
.prescrip_class ::v-deep .uni-list-item__container {
  padding: 0;
  border-bottom: 0.021333rem solid #ececec;
}
.prescrip_class ::v-deep .list-item {
  border-bottom: 0.021333rem solid #ececec;
}
.prescrip_class ::v-deep .uni-list--border:after {
  background-color: transparent !important;
  height: 0 !important;
}
</style>
<style lang="scss" scoped>
.gridClass {
  background-color: #fff;
  height: 18.346667rem;
  overflow-y: scroll;
  overflow-x: hidden;
  z-index: 1100;
  .grid_wrap {
    height: auto;
    border-top: 0.021333rem solid #ececec;
    border-bottom: 0.021333rem solid #ececec;
    padding: 0.597333rem 0.682667rem 0.682667rem 0.682667rem;
    .prescrip_class {
      border-bottom: 0.021333rem solid #ececec;
    }
    .card_wrap {
      border-top: 0.021333rem solid #ececec;
      .fst_row {
        color: #222;
        font-size: 0.64rem;
        display: flex;
        justify-content: space-between;
        width: 100%;
        padding: 0.64rem 0.64rem 0 0.512rem;
        box-sizing: border-box;
        text:last-child {
          color: #0089ff;
        }
      }
      .row {
        color: #888;
        padding-bottom: 0.64rem;
        font-size: 0.64rem;
        .text {
          color: #222;
          margin-right: 0.426667rem;
        }
      }
    }
    .input_wrap {
      display: flex;
      padding: 0 0.64rem 0 0.512rem;
      align-items: center;
      justify-content: space-between;
      height: 2.005333rem;
      .input_row {
        display: flex;
        width: 3.84rem;
        height: 100%;
        align-items: center;
        .input_con {
          text-align: right;
        }
        .unit {
          margin-left: 0.213333rem;
        }
      }
    }
    .row_wrap {
      width: 100%;
      // min-height: 1.706667rem;
      height: auto;
      position: relative;
      display: flex;
      box-sizing: border-box;
      .add_img {
        width: 0.853333rem;
        height: 0.853333rem;
        position: absolute;
        right: 0.042667rem;
      }
      .title,
      .diagnose_wrap {
        // min-width: 1.92rem;
        font-size: 0.64rem;
        font-weight: 400;
        color: #222222;
        line-height: 0.853333rem;
      }
      .title {
        font-size: 0.64rem;
        font-weight: 400;
        color: #888888;
      }
      .diagnose_wrap {
        // width: 12.8rem;
        height: auto;
        .symptom_text {
          font-family: PingFangSC-Regular, PingFang SC !important;
        }
        .meng_text {
          font-family: PingFang-SC-Medium, PingFang SC, Menksoft Budun !important;
        }
        // padding: .213333rem;
        // margin: 0 .213333rem .213333rem 0;
      }
    }
    .fst_row {
      margin-bottom: 0.512rem;
    }
  }
  .serviceType {
    // width: 2.901333rem;
    height: 0.981333rem;
    border-radius: 0.085333rem;
    text-align: end;
    line-height: 0.981333rem;
    font-size: 0.64rem;
    font-weight: 400;
    color: #222;
  }
  .patientName {
    font-size: 0.725333rem;
    font-family: PingFang SC;
    font-weight: bold;
    color: #222222;
    .sex,
    .age {
      font-size: 0.64rem;
      font-weight: 400;
      color: #222222;
      line-height: 0.64rem;
      margin-left: 0.298667rem;
    }
    .sex {
      margin-left: 0.512rem;
    }
  }
  .preType {
    width: max-content;
    height: 0.768rem;
    border-radius: 0.085333rem;
    border: 0.021333rem solid #0089ff;
    text-align: center;
    line-height: 0.768rem;
    padding: 0 0.256rem;
    color: #0089ff;
    margin-top: 0.32rem;
    font-size: 0.512rem;
  }
}
.footer-box {
  text-align: center;
  width: 14.634667rem;
  height: 1.877333rem;
  background: #0089ff;
  border-radius: 0.938667rem;
  line-height: 1.877333rem;
  font-size: 0.682667rem;
  font-weight: 500;
  // margin-left: .170667rem;
  .btn {
    color: #fff;
  }
}
</style>
